import { createAsyncThunk } from "@reduxjs/toolkit";
import { TalesTournament } from "../../../utils/types/TalesTournament";
import { db } from "../../../firebase/config";

export const toggleTournamentVisibility = createAsyncThunk(
  "tournament/toggleVisibility",
  async (tournament: TalesTournament) => {
    try {
      const querySnapshot = await db
        .collection("tournament")
        .where("title", "==", tournament.title)
        .get();

      return querySnapshot.docs[0].ref.set({
        ...tournament,
        show: !tournament.show,
      });
    } catch (e: any) {
      console.log(e);

      return Promise.reject(
        `Tournament non ${tournament.show ? "nascosto" : "mostrato"}, ${e.message}`,
      );
    }
  },
);
